import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTheme } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
const LabelContainer = styled.div`
`

/**
 * Label is a general label which translates the children prop if required.
 * It's color will be set by some parent component.
 *
 * @param {object} props see Label.propTypes
 * @returns {React.ReactElement} - React component
 */
const Label = props => {
  const { t } = useTranslation()
  const theme = useTheme()
  const color = props.color === 'primary' ? theme.palette.primary.main : undefined
  return ( 
    <LabelContainer id={props.id} className={props.className} style={{ color, ...props.style }} theme={theme} noTranslate={true}>
      {typeof props.children !== 'string' ? props.children : props.noTranslate ? props.children : t(props.children)}
    </LabelContainer>
  )
}

Label.propTypes = {
  /**
   id for the control.
   */
  id: PropTypes.string,
  /**
   Label as a child.
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  /**
   Label style,
   */
  style: PropTypes.object,
  /**
   Label classname.
   */
  className: PropTypes.string,
  /**
   Prevents the language translation of the children if it is a string.
   */
  noTranslate: PropTypes.bool,
  /**
   MUI color for the Label.
   */
  color: PropTypes.oneOf(['primary', 'default']),
}

Label.defaultProps = {
  noTranslate: false
}

export default Label
